module.exports = __webpack_public_path__ + "img/whatsApp.3d834db1.svg";